import { isAppWindow } from "@/shared/lib/appWindow";

/**
 * Покупки поиска в окне приложения MY REVIVE — ЖДЁТ РЕШЕНИЯ ВЛАДЕЛЬЦА (11.10.2026).
 *
 * Окно приложения — Trusted Web Activity из сборки Google Play: для Google Play это часть
 * приложения. Правила оплаты Google Play (Payments policy): цифровое содержимое внутри
 * приложения продаётся через Google Play Billing, и приложение не ведёт человека к другому
 * способу оплаты — «in-app webviews, buttons, links, messaging … or other calls to action».
 * Значит, утверждённый запасной путь «Продлить → сайт во внешнем браузере» правилам тоже не
 * соответствует (та же кнопка к оплате мимо Google Play). Исключения — программы альтернативной
 * оплаты и внешних предложений с записью в них: по ревью 11.10 (Google Play Help, answer
 * 15582165) в США с 29.10.2025 разрешены ссылки на внешнюю оплату и другие способы оплаты по
 * программе Google (отчёт о сборах — с 01.10.2026); в других странах — свои программы. Мы ни в
 * одну не записаны.
 *
 * Пока владелец не решил — "stripe": как было до 11.10 (окно пакетов, «Продлить», пополнение
 * токенов и оплата Stripe — и в окне приложения), ни одна существующая кнопка не меняется.
 *
 * "none" — в окне приложения покупок поиска нет. ВКЛЮЧАТЬ ТОЛЬКО ВМЕСТЕ С доделкой (ревью
 * 11.10): сейчас при "none" прячутся окно пакетов, «Продлить» и пополнение у ворот лекции, но
 * (1) окно пополнения токенов страниц поиска и чата специалиста (RefillModal /
 * createQuestionsCheckout: PublicQuestionsPageContent, QuestionsPageContent, SpecialistChatPage)
 * и «Оплатить месяц» специалисту остаются; (2) нажатие на закрытый ответ / подборку
 * (usePlanSearch.blocked → окно пакетов) и «+ Новый вопрос» без вопросов в чате ничего не
 * показывают — им нужна видимая строка (SearchClosedCard / DailyCapLine) вместо окна.
 */
export type AppWindowSales = "none" | "stripe";
export const APP_WINDOW_SALES = "stripe" as AppWindowSales;

/** Правило: покупку поиска показываем везде, кроме окна приложения при "none". */
export const salesAllowed = (mode: AppWindowSales, inAppWindow: boolean): boolean =>
    mode === "stripe" || !inAppWindow;

/** Можно ли здесь показывать покупку поиска (пакеты, «Продлить», пополнение токенов). */
export const planSalesHere = (): boolean => salesAllowed(APP_WINDOW_SALES, isAppWindow());
